const authRoles = {
	admin: ['admin', 'super_admin'],
	onlyGuest: []
};

export default authRoles;
